import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import dayjs from 'dayjs';

@Component({
    selector: 'timepicker-free-text',
    templateUrl: 'timepicker-free-text.component.html',
    styleUrls: ['timepicker-free-text.component.scss'],
    standalone: true,
    imports: [FormsModule]
})
export class TimepickerFreeTextComponent {
    dateView: string;
    roundTo = 0.25;
    maxViewValue = 24;
    hasChanges: boolean;

    @Input()
    inputType = 'text';

    @Input()
    dataQaId: string;

    @Input()
    set dateModel(value: Date | string) {
        const date = dayjs(value);
        if (date.isValid() && !this.isIosMinDate(value)) {
            const hours = date.hour();
            const minutes = date.minute();
            const minutesFree = parseFloat((minutes / 60).toFixed(2));
            this.dateView = String(hours + minutesFree);
        }
    }

    get dateModel() {
        const _date = dayjs().startOf('day').add(this.roundedDateView, 'hour');
        return _date.isValid() ? _date.toDate() : null;
    }

    get roundedDateView(): number {
        const newVal = Math.round(parseFloat(this.dateView) / this.roundTo) * this.roundTo;
        return Number((newVal > this.maxViewValue ? 0 : newVal).toFixed(2));
    }

    @ViewChild('inputDate', { static: true })
    inputDate: ElementRef;

    @Output()
    dateModelChange: EventEmitter<Date | string> = new EventEmitter<Date | string>();

    @Output()
    edited: EventEmitter<Date | string> = new EventEmitter<Date | string>();

    onChange() {
        this.dateModelChange.emit(this.dateModel);
        this.hasChanges = true;
    }

    onBlur() {
        this.edited.emit(this.dateModel);
    }

    onClick() {
        this.inputDate.nativeElement.select();
    }

    private isIosMinDate(value: any) {
        const date = dayjs(value);
        //IOS issue
        let isMinDate = false;
        if (value?.toString()) {
            if (value.toString().includes('0001')) {
                if (date.year() === 2001) {
                    isMinDate = true;
                }
            }
        }
        return isMinDate;
    }
}
